import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import API from "@/axios";
import {
  Member,
  TeamState,
  InviteSenderPayload,
  ToggleTeamMemberStatusPayload,
} from "../types";

const actions: ActionTree<TeamState, RootState> = {
  getInviteSender({ commit }, payload: InviteSenderPayload) {
    return API.get(
      `/invitations?token=${payload.token}&email=${payload.email}`
    ).then((response) => {
      const { user } = response.data.data;
      commit("setInviteSender", user);
    });
  },
  fetchSuperAdminCount({ commit }) {
    return API.get(
      `/users/superadmin-count`
    ).then((response) => {
      console.log(response);
      const { total } = response.data;
      commit("setSuperAdminCount", total);
    });
  },
  fetchMembers({ commit }) {
    return API.get("/users").then((response) => {
      const { data: results } = response;
      if (results) {
        commit("setUsers", results);
      }
    });
  },
  fetchPendingMembers({ commit }) {
    return API.get("/invitations/pending").then((response) => {
      //Results are in data.data
      const { data: results } = response;
      if (results) {
        commit("setPendingMembers", results.data);
      }
    });
  },
  fetchCurrentPendingMember({ commit, state }, memberId) {
    const currentPendingMembers = state.pendingMembers?.filter(
      ({ id }) => id === memberId
    );
    if (currentPendingMembers) {
      //Might return multiple entries, take the first
      const member = currentPendingMembers[0];
      commit("setCurrentPendingMember", member);
    }
  },
  fetchCurrentTeamMember({ commit }, memberId) {
    return API.get(`/users/${memberId}`).then((response) => {
      const { data: results } = response;
      if (results) {
        commit("setCurrentMember", results);
      }
      return response;
    });
  },
  updateCurrentTeamMember(context, payload: Member) {
    const { id: memberId } = payload;
    return API.post(`/users/${memberId}/update`, {
      ...payload,
    });
  },
  inviteMember(context, payload: Member) {
    return API.post("/invitations", {
      ...payload,
    });
  },
  toggleTeamMemberStatus(context, payload: ToggleTeamMemberStatusPayload) {
    return API.post(`/users/${payload.memberId}/${payload.action}`);
  },
  cancelPendingInvitation(context, memberId) {
    return API.post(`invitations/${memberId}/cancel`, {
      id: memberId,
    });
  },
};

export default actions;
